"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherTableColumnProperties = exports.TextTableColumnProperties = exports.DateTableColumnProperties = exports.PercentageTableColumnProperties = exports.CurrencyTableColumnProperties = exports.TableColumnPropertyTypeMapping = exports.DocxTemplateTableColumnProperties = exports.DocxTemplateTableColumnPropertiesIterable = exports.OtherProperties = exports.TextProperties = exports.DateProperties = exports.PercentageProperties = exports.CurrencyProperties = exports.PropertyTypeMapping = exports.DocxTemplateProperties = exports.DocxTemplatePropertiesIterable = exports.PropertyType = exports.PropertyTypeIterable = void 0;
exports.PropertyTypeIterable = [
    'CURRENCY',
    'PERCENTAGE',
    'DATE',
    'TEXT',
    'OTHER',
];
exports.PropertyType = {
    CURRENCY: 'CURRENCY',
    PERCENTAGE: 'PERCENTAGE',
    DATE: 'DATE',
    TEXT: 'TEXT',
    OTHER: 'OTHER',
};
exports.DocxTemplatePropertiesIterable = [
    'borrowingBaseAmount',
    'borrowingBaseReserveAmount',
    'cashReserveAmount',
    'collectionsRecycleAmount',
    'commitmentAmount',
    'drawRequestTotalAmount',
    'remainingCollectionsAmount',
    'drawRequestComponentAmountByCapitalProvider',
    'currentPrincipalBalance',
    'totalMaxAdvanceAmount',
    'prepaymentAmount',
    'newlyAssignedTotalExposure',
    'currentDate',
    'cutoffDate',
    'collectionsRecycleTargetFundingDate',
    'drawRequestTargetFundingDate',
    'prepaymentDate',
    'purchaseDate',
    'reportingDate',
    'fundingRequestNumber',
    'wiringInstructionsAccountName',
    'wiringInstructionsAccountNumber',
    'wiringInstructionsInstitutionName',
    'wiringInstructionsRoutingNumber',
    'initialFundingRequestNumber',
];
exports.DocxTemplateProperties = {
    borrowingBaseAmount: 'borrowingBaseAmount',
    borrowingBaseReserveAmount: 'borrowingBaseReserveAmount',
    cashReserveAmount: 'cashReserveAmount',
    collectionsRecycleAmount: 'collectionsRecycleAmount',
    commitmentAmount: 'commitmentAmount',
    // corresponds to drawRequestAmount seen in templates
    drawRequestTotalAmount: 'drawRequestTotalAmount',
    remainingCollectionsAmount: 'remainingCollectionsAmount',
    drawRequestComponentAmountByCapitalProvider: 'drawRequestComponentAmountByCapitalProvider',
    currentPrincipalBalance: 'currentPrincipalBalance',
    totalMaxAdvanceAmount: 'totalMaxAdvanceAmount',
    prepaymentAmount: 'prepaymentAmount',
    newlyAssignedTotalExposure: 'newlyAssignedTotalExposure',
    currentDate: 'currentDate',
    cutoffDate: 'cutoffDate',
    collectionsRecycleTargetFundingDate: 'collectionsRecycleTargetFundingDate',
    drawRequestTargetFundingDate: 'drawRequestTargetFundingDate',
    prepaymentDate: 'prepaymentDate',
    purchaseDate: 'purchaseDate',
    reportingDate: 'reportingDate',
    fundingRequestNumber: 'fundingRequestNumber',
    wiringInstructionsAccountName: 'wiringInstructionsAccountName',
    wiringInstructionsAccountNumber: 'wiringInstructionsAccountNumber',
    wiringInstructionsInstitutionName: 'wiringInstructionsInstitutionName',
    wiringInstructionsRoutingNumber: 'wiringInstructionsRoutingNumber',
    initialFundingRequestNumber: 'initialFundingRequestNumber',
};
exports.PropertyTypeMapping = {
    borrowingBaseAmount: exports.PropertyType.CURRENCY,
    borrowingBaseReserveAmount: exports.PropertyType.CURRENCY,
    cashReserveAmount: exports.PropertyType.CURRENCY,
    collectionsRecycleAmount: exports.PropertyType.CURRENCY,
    commitmentAmount: exports.PropertyType.CURRENCY,
    drawRequestTotalAmount: exports.PropertyType.CURRENCY,
    drawRequestComponentAmountByCapitalProvider: exports.PropertyType.CURRENCY,
    remainingCollectionsAmount: exports.PropertyType.CURRENCY,
    currentPrincipalBalance: exports.PropertyType.CURRENCY,
    totalMaxAdvanceAmount: exports.PropertyType.CURRENCY,
    prepaymentAmount: exports.PropertyType.CURRENCY,
    newlyAssignedTotalExposure: exports.PropertyType.CURRENCY,
    currentDate: exports.PropertyType.DATE,
    cutoffDate: exports.PropertyType.DATE,
    collectionsRecycleTargetFundingDate: exports.PropertyType.DATE,
    drawRequestTargetFundingDate: exports.PropertyType.DATE,
    prepaymentDate: exports.PropertyType.DATE,
    purchaseDate: exports.PropertyType.DATE,
    reportingDate: exports.PropertyType.DATE,
    fundingRequestNumber: exports.PropertyType.TEXT,
    wiringInstructionsAccountName: exports.PropertyType.TEXT,
    wiringInstructionsAccountNumber: exports.PropertyType.TEXT,
    wiringInstructionsInstitutionName: exports.PropertyType.TEXT,
    wiringInstructionsRoutingNumber: exports.PropertyType.TEXT,
    initialFundingRequestNumber: exports.PropertyType.OTHER,
};
exports.CurrencyProperties = [
    exports.DocxTemplateProperties.borrowingBaseAmount,
    exports.DocxTemplateProperties.borrowingBaseReserveAmount,
    exports.DocxTemplateProperties.cashReserveAmount,
    exports.DocxTemplateProperties.collectionsRecycleAmount,
    exports.DocxTemplateProperties.commitmentAmount,
    exports.DocxTemplateProperties.drawRequestTotalAmount,
    exports.DocxTemplateProperties.remainingCollectionsAmount,
    exports.DocxTemplateProperties.drawRequestComponentAmountByCapitalProvider,
    exports.DocxTemplateProperties.currentPrincipalBalance,
    exports.DocxTemplateProperties.totalMaxAdvanceAmount,
    exports.DocxTemplateProperties.prepaymentAmount,
    exports.DocxTemplateProperties.newlyAssignedTotalExposure,
];
exports.PercentageProperties = [];
exports.DateProperties = [
    exports.DocxTemplateProperties.currentDate,
    exports.DocxTemplateProperties.cutoffDate,
    exports.DocxTemplateProperties.collectionsRecycleTargetFundingDate,
    exports.DocxTemplateProperties.drawRequestTargetFundingDate,
    exports.DocxTemplateProperties.prepaymentDate,
    exports.DocxTemplateProperties.purchaseDate,
    exports.DocxTemplateProperties.reportingDate,
];
exports.TextProperties = [
    exports.DocxTemplateProperties.fundingRequestNumber,
    exports.DocxTemplateProperties.wiringInstructionsAccountName,
    exports.DocxTemplateProperties.wiringInstructionsAccountNumber,
    exports.DocxTemplateProperties.wiringInstructionsInstitutionName,
    exports.DocxTemplateProperties.wiringInstructionsRoutingNumber,
];
exports.OtherProperties = [
    exports.DocxTemplateProperties.initialFundingRequestNumber,
];
exports.DocxTemplateTableColumnPropertiesIterable = [
    'finleyReceivableId',
    'externalReceivableId',
    'purchasePrice',
    'purchasePercentageRate',
    'exposure',
    'agreementCreationDate',
];
exports.DocxTemplateTableColumnProperties = {
    finleyReceivableId: 'finleyReceivableId',
    externalReceivableId: 'externalReceivableId',
    purchasePrice: 'purchasePrice',
    purchasePercentageRate: 'purchasePercentageRate',
    exposure: 'exposure',
    agreementCreationDate: 'agreementCreationDate',
};
exports.TableColumnPropertyTypeMapping = {
    purchasePrice: exports.PropertyType.CURRENCY,
    purchasePercentageRate: exports.PropertyType.PERCENTAGE,
    exposure: exports.PropertyType.CURRENCY,
    finleyReceivableId: exports.PropertyType.OTHER,
    externalReceivableId: exports.PropertyType.OTHER,
    agreementCreationDate: exports.PropertyType.DATE,
};
exports.CurrencyTableColumnProperties = [
    exports.DocxTemplateTableColumnProperties.purchasePrice,
    exports.DocxTemplateTableColumnProperties.exposure,
];
exports.PercentageTableColumnProperties = [
    exports.DocxTemplateTableColumnProperties.purchasePercentageRate,
];
exports.DateTableColumnProperties = [
    exports.DocxTemplateTableColumnProperties.agreementCreationDate,
];
exports.TextTableColumnProperties = [
    exports.DocxTemplateTableColumnProperties.finleyReceivableId,
    exports.DocxTemplateTableColumnProperties.externalReceivableId,
];
exports.OtherTableColumnProperties = [];
//# sourceMappingURL=DocxTemplate.js.map